<template>
  <div class="col-lg-4 col-md-6 col-8 mb-2">
    <div
      :class="`d-flex align-items-center justify-content-between shadow
    bg-white rounded py-2 border ${border} c-pointer`"
    >
      <div class="mx-4">
        <i :class="`fas ${icon} fs-26`"></i>
      </div>
      <div>
        <span class="c-black d-inline fs-15">
          {{ text }}
        </span>
      </div>
      <div class="mr-2">
        <b-badge
          :class="`${background} c-white fs-14 p-2 py-0 m-2 font-weight-lighter`"
        >
          {{ numberShopKeeper }}
        </b-badge>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    numberShopKeeper: {
      type: Number,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    background: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    border: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped></style>
